export const shelf = {
  title: "My Shelf",
  pageTitle: "My Shelf | GlobalComix",
  tabs: {
    library: "Library",
    purchases: "Purchases",
  },
};
